module.exports = __webpack_public_path__ + "static/media/ios_home_plus.c8722a3f.svg";